import React, { useMemo, useRef } from "react";
import ReactMarkdown, { Components } from "react-markdown";
import gfm from "remark-gfm";
import CodeBlock from "./CodeBlock";

interface AgentMessageContentProps {
  id: string;
  message: string;
}

/**
 * Renders markdown + code blocks for agent/user messages (no UserContextData).
 * Reuses CodeBlock for copy/run/insert actions.
 */
export function AgentMessageContent({ id, message }: AgentMessageContentProps) {
  const codeBlockIndexRef = useRef(0);
  codeBlockIndexRef.current = 0;
  const components: Components = useMemo(
    () => ({
      code: ({ node, inline, className, children, ...props }) => {
        if (inline) {
          return (
            <code className={className} {...props}>
              {children}
            </code>
          );
        }
        const match = /language-(\w+)/.exec(className || "");
        const language = match ? match[1] : "";
        const code = String(children).replace(/\n$/, "");
        codeBlockIndexRef.current += 1;
        const codeBlockId = `${id}-code-${codeBlockIndexRef.current}`;
        return <CodeBlock id={codeBlockId} language={language} code={code} />;
      },
    }),
    [id]
  );

  return (
    <ReactMarkdown className="chatMessage mt-1" remarkPlugins={[gfm]} components={components}>
      {message}
    </ReactMarkdown>
  );
}
